export const getCurrentLearningYear = () => {
  const currentDate = new Date();
  const currentFullYear = currentDate.getFullYear();

  const startYear = currentDate.getMonth() < 8 ? currentFullYear - 1 : currentFullYear;

  return `${startYear}-${startYear + 1}`;
};
